import LoggerService from './LoggerService'
// Task 01 / STEP-02 (C-1): this file used to also carry Gleap-specific
// widget-trigger plumbing (GLEAP_WIDGET_CONFIGS, handleGleapWidget,
// triggerDynamicGleapWidget). That has been removed. The exports below are
// Orbital (window.orbital) product-discovery calls -- a separate, unrelated,
// still-active integration (StudentDashboard.vue's segment trigger,
// AuthService.js's logout reset) -- and are kept exactly as they were.
const orbital = window.orbital

function isValidUserForSegment(user, properties, featureFlags) {
  const { minSessions, maxSessions, userType, flagFilters } = properties
  const validFlags =
    !flagFilters || flagFilters.some(flag => featureFlags[flag])

  return (
    user.pastSessions.length >= minSessions &&
    user.pastSessions.length <= maxSessions &&
    userType === user.type &&
    validFlags
  )
}

export default {
  trigger(discoveryId) {
    orbital('trigger', discoveryId)
  },

  triggerDynamicSegment(user, segmentProperties = [], featureFlags) {
    if (!segmentProperties.length) return

    try {
      for (const properties of segmentProperties) {
        if (isValidUserForSegment(user, properties, featureFlags)) {
          const { discoveryId } = properties
          orbital('trigger', discoveryId)
        }
      }
    } catch (error) {
      LoggerService.noticeError(error)
    }
  },

  reset() {
    orbital('reset')
  },
}
